import { createContext } from 'react';
import { emptyFunc } from '@shared/react';
import { PaginationOptions } from '@features/Pagination';
import { ITransactionDesc } from './OrderTableProvider';
import { ILogo } from '@widgets/AccountLevelPositionsTable/lib/PositionsTableProvider/PositionsTableContext';

type DateRange = [string | null, string | null];

export interface IOrderTableContext {
    OrderBody: any[];
    logoLoading: boolean;
    arrayWithLogos: ILogo[];
    paginationOptions: PaginationOptions | null;
    sortFieldName: string;
    orderLoading: boolean;
    desc: ITransactionDesc | null;
    orderStatus: string | null;
    orderType: string | null;
    riaScreen: boolean | null;
    setOrderIdentifier: (symbol: string) => void;
    onOrderRowClick: (order: any) => void;
    onAssignPositionClick: (order: any) => void;
    setOrderStatus: (value: string) => void;
    setOrderType: (value: string) => void;
    setRiaScreen: (value: boolean) => void;
}

export const OrderTableContext = createContext<IOrderTableContext>({
    OrderBody: [],
    arrayWithLogos: [],
    logoLoading: false,
    paginationOptions: null,
    sortFieldName: '',
    orderLoading: false,
    desc: null,
    orderStatus: '',
    orderType: '',
    riaScreen: true,
    setOrderIdentifier: emptyFunc,
    onOrderRowClick: emptyFunc,
    onAssignPositionClick: emptyFunc,
    setOrderStatus: emptyFunc,
    setOrderType: emptyFunc,
    setRiaScreen: emptyFunc,
});
